import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useCommissionsStore = defineStore('commissionsStore', {
  state: () => ({
    endpoint: 'commissions',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
